import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withTheme } from 'styled-components'
// Components
import { Button, TextButton } from '../../../Reusable/Button'
import { Flex, FlexColumn } from '../../../Reusable/Container'
import { Text } from '../../../Reusable/Text'
import { LabeledInput } from '../../../Reusable/Input'
import { apiPOSTReq, getJwt } from '../../../../Utils/api'
import environment from '../../../../environment'
import { ErrorAlert } from '../../../Reusable/Alert'
import { Image } from '../../../Reusable/Image'
import { Switch, Upload, message, Tooltip } from 'antd'
import { PlusOutlined } from '@ant-design/icons';
import Info from '../../../../Images/info.png'

class Index extends Component {
    state = {
        customer: this.props.customer,
        loading: false,
        verificationStatus: this.props.customer.verificationStatus,
        paymentConfirmation: this.props.customer.paymentConfirmation,
        areligible: this.props.customer.areligible,
        invoiceEligibility: '',
        concentrationLimit: '',
        advanceRate: '',
        crossAgeLimit: '',
        reason: '',
        invoiceEligibilityChanged: false,
        concentrationLimitChanged: false,
        advanceRateChanged: false,
        crossAgeLimitChanged: false
    }

    componentDidMount() {
        const { businessId } = this.props
        this.fetchCustomerAttributes(businessId);
        this.fetchAuditLogs(businessId);
        getJwt((err, jwt) => {
            this.setState({ jwt });
        });
    }

    fetchCustomerAttributes = () => {
        const { customer } = this.props
        var body = {
            "clientBusinessId": customer.businessId,
            customerId: customer.customerId
        }

        this.setState({ loading: true })
        apiPOSTReq(`${environment.opsBaseUrl}/ops/fetchCustomerAttributes`, null, body, (err, resp) => {
            this.setState({ loading: false })
            try {
                const data = resp || {}
                if (data.customerAttributes) {
                    var customerAttributes = data.customerAttributes
                    var invoiceEligibility = customerAttributes.filter(
                        item => {
                            return (item.name == "DaysPastInvoiceDate")
                        }
                    )

                    if (invoiceEligibility.length > 0) {
                        var invoiceEligibility = invoiceEligibility[0].value
                        this.setState({
                            invoiceEligibility: invoiceEligibility
                        })
                    }

                    var concentrationLimit = customerAttributes.filter(
                        item => {
                            return (item.name == "Concentration")
                        }
                    )

                    if (concentrationLimit.length > 0) {
                        var concentrationLimit = concentrationLimit[0].value
                        this.setState({
                            concentrationLimit: concentrationLimit * 100
                        })
                    }

                    var advanceRate = customerAttributes.filter(
                        item => {
                            return (item.name == "AdvanceRate")
                        }
                    )

                    if (advanceRate.length > 0) {
                        var advanceRate = advanceRate[0].value
                        this.setState({
                            advanceRate: parseFloat(advanceRate * 100).toFixed(2)
                        })
                    }

                    var crossAgeLimit = customerAttributes.filter(
                        item => {
                            return (item.name == "CrossAged")
                        }
                    )

                    if (crossAgeLimit.length > 0) {
                        var crossAgeLimit = crossAgeLimit[0].value
                        this.setState({
                            crossAgeLimit: crossAgeLimit * 100
                        })
                    }

                    this.setState({
                        paymentConfirmation: data.paymentConfirmation,
                        customerAttributes: customerAttributes
                    })

                    // this.fetchARData()
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            }
        })
    }

    fetchAuditLogs = () => {
        const { customer } = this.props
        var body = {
            "clientBusinessId": customer.businessId,
            customerId: customer.customerId
        }

        this.setState({ loading: true })
        apiPOSTReq(`${environment.opsBaseUrl}/ops/fetchAuditLogs`, null, body, (err, resp) => {
            this.setState({ loading: false })
            const data = resp || {}
            if (data.auditLogs) {

                var auditlogs = data.auditLogs;
                var latestAuditLog = auditlogs[auditlogs.length - 1];

                this.setState({
                    reason: latestAuditLog?.reason
                })
            } else {
                throw Error(data.responseMessage || data.error)
            }

        })
    }

    handleInvoiceEligibility = (event) => {
        const target = event.target
        this.setState({ invoiceEligibility: target.value, invoiceEligibilityChanged: true })
    }

    handleConcentrationLimit = (event) => {
        const target = event.target
        this.setState({ concentrationLimit: target.value, concentrationLimitChanged: true })
    }

    handleAdvanceRate = (event) => {
        const target = event.target
        this.setState({ advanceRate: target.value, advanceRateChanged: true })
    }

    handleCrossAgeLimit = (event) => {
        const target = event.target
        this.setState({ crossAgeLimit: target.value, crossAgeLimitChanged: true })
    }

    handleReason = (event) => {
        const target = event.target
        this.setState({ reason: target.value })
    }

    handleVerificationStatus = (checked) => {
        if (!checked) {
            this.setState({
                verificationStatus: "REQUESTED",
                paymentConfirmation: false,
                areligible: false,
                savedFileList: []
            });
        }
        else {
            this.setState({
                verificationStatus: "VALIDATED",
                paymentConfirmation: true,
                areligible: true
            });
        }
    }

    handlePaymentConfirmation = (checked) => {
        this.setState({
            paymentConfirmation: checked,
        });
    }

    handleAreligible = (checked) => {
        this.setState({
            areligible: checked
        });
    }

    handleSubmit = () => {
        const { invoiceEligibility, concentrationLimit, crossAgeLimit, advanceRate, reason, paymentConfirmation, concentrationLimitChanged, crossAgeLimitChanged, invoiceEligibilityChanged, areligible, verificationStatus, advanceRateChanged } = this.state
        const { customer, email } = this.props
        var { savedFileList } = this.state;
        var savedFileList = savedFileList || [];

        if (reason != null && reason != '') {
            this.setState({ loading: true })

            var username = email
            var request = {
                "clientBusinessId": customer.businessId,
                "userName": username,
                "reason": reason,
                "paymentConfirmation": paymentConfirmation,
                "verificationStatus": verificationStatus,
                "arEligible": areligible,
                "creditOpsCustomerParams": {
                    "customerId": customer.customerId,
                    "customerAttributes": []
                },
                attachmentUrls: savedFileList
            }

            if (invoiceEligibilityChanged) {
                request["creditOpsCustomerParams"]["customerAttributes"].push(
                    {
                        "name": "DaysPastInvoiceDate",
                        "type": "IneligibilityDaysPastInvoiceDate",
                        "value": invoiceEligibility
                    }
                )
            }
            if (concentrationLimitChanged && concentrationLimit != '') {
                if (isNaN(parseFloat(concentrationLimit))) {
                    this.setState({ loading: false })
                    ErrorAlert({ description: "Please enter a valid Concentration Limit." });
                    return
                }

                request["creditOpsCustomerParams"]["customerAttributes"].push(
                    {
                        "name": "Concentration",
                        "type": "IneligibilityConcentration",
                        "value": parseFloat(concentrationLimit) / 100
                    }
                )
            }

            if (advanceRateChanged && advanceRate != '') {
                if (isNaN(parseFloat(advanceRate))) {
                    this.setState({ loading: false })
                    ErrorAlert({ description: "Please enter a valid Advance Rate." });
                    return
                }

                request["creditOpsCustomerParams"]["customerAttributes"].push(
                    {
                        "name": "AdvanceRate",
                        "type": "AdvanceRate",
                        "value": parseFloat(advanceRate) / 100
                    }
                )
            }

            if (crossAgeLimitChanged) {
                request["creditOpsCustomerParams"]["customerAttributes"].push(
                    {
                        "name": "CrossAged",
                        "type": "IneligibilityCrossAged",
                        "value": crossAgeLimit / 100
                    }
                )
            }

            apiPOSTReq(`${environment.opsBaseUrl}/ops/creditOps/setCustomerParams`, null, request, (err, resp) => {
                this.setState({ loading: false })
                try {
                    const data = resp
                    if (data.result) {
                        if (err) throw new Error(err)

                        this.props.closeEdit()
                    } else {
                        throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                    }
                } catch (error) {
                    console.log("ERRR getAccounts", error, err, resp)
                }
            })
        }
        else {
            if (!reason || reason == "") {
                this.setState({ errorField: "reason", errorMessage: "Please enter a valid reason." })
                return
            }
        }
    }

    render() {
        const { loading, paymentConfirmation, concentrationLimit, advanceRate, reason, verificationStatus, areligible, errorField, errorMessage, crossAgeLimit, invoiceEligibility } = this.state
        const { theme } = this.props
        var verification = verificationStatus == "VALIDATED";
        var uploadProps = {
            action: `${environment.apiBaseUrl}/file/upload`,
            headers: {
                businesskey: this.props.aionStore.BusinessUniqueKey,
                jwt: this.state.jwt
            },
            beforeUpload: (doc) => {
                this.setState({ uploading: true })
                var maxFileSize = 10240; // 10MB
                const uploadedFileSizeKiloBytes = doc.size / 1024
                if (uploadedFileSizeKiloBytes > maxFileSize) {
                    message.error(`File size is greater than 10MB`);
                    this.setState({ uploading: false });
                    return false;
                }
            },
            showUploadList: true,
            multiple: true,
            onChange: (info) => {
                var { savedFileList } = this.state;
                var savedFileList = savedFileList || [];
                var file = info.file;
                console.log("info file", info, file, savedFileList);
                var { status, response, name, url } = file;
                if (status === "done") {
                    response = response || {};
                    console.log(response);
                    savedFileList.push({
                        fileName: name,
                        uri: (response.UploadedUrls || response.uploadedUrls || [])[0],
                        file: this.props.includebase64 ? file : null
                    });
                    this.setState({ uploading: false })
                }
                if (status === "removed") {
                    var fileList = [];
                    for (var i = 0; i < savedFileList.length; i++) {
                        if (savedFileList[i].fileName != file.name) {
                            fileList.push(savedFileList[i]);
                        }
                    }

                    savedFileList = fileList;
                }

                savedFileList = savedFileList.map(item => ({ ...item, url: item.uri }));
                this.setState({ savedFileList: savedFileList });
            }
        };

        return (
            <FlexColumn start style={{ width: 616 }}>
                <FlexColumn>
                    <Text margin='0 0 40px' size='24px' weight={500} color='#444444'>Payer Settings</Text>
                    <Flex start style={{ marginBottom: 15 }}>
                        <FlexColumn style={{ width: "30%" }}>
                            <Text color='#7384AA' size='14px' weight={400}>Verification Status</Text>
                        </FlexColumn>
                        <FlexColumn>
                            <Switch size="large" checked={verification} onChange={(checked) => this.handleVerificationStatus(checked)} />
                        </FlexColumn>
                    </Flex>
                    {
                        verification && <>
                            <Flex start style={{ marginBottom: 15 }}>
                                <FlexColumn style={{ width: "30%" }}>
                                    <Text color='#7384AA' size='14px' weight={400}>Payment Confirmation</Text>
                                </FlexColumn>
                                <FlexColumn>
                                    <Switch size="large" checked={paymentConfirmation} disabled onChange={(checked) => this.handlePaymentConfirmation(checked)} />
                                </FlexColumn>
                            </Flex>
                            <Flex start style={{ marginBottom: 15 }}>
                                <FlexColumn style={{ width: "30%" }}>
                                    <Text color='#7384AA' size='14px' weight={400}>AR Eligible</Text>
                                </FlexColumn>
                                <FlexColumn>
                                    <Switch size="large" checked={areligible} disabled onChange={(checked) => this.handleAreligible(checked)} />
                                </FlexColumn>
                            </Flex>
                            <Flex start>
                                <Upload
                                    {...uploadProps}
                                >
                                    <TextButton loading={this.state.uploading} text={"Add Attachments"} color="#40a9ff" icon={<PlusOutlined style={{ fontSize: 14, width: 24, height: 24, color: "#40a9ff" }} />} />
                                </Upload>
                            </Flex>
                        </>
                    }
                    <Flex start style={{ marginBottom: 15 }}>
                        <LabeledInput
                            autoFocus
                            label={
                                <>
                                    Invoice Eligibility Period
                                    <Tooltip overlayInnerStyle={{minWidth: 700 }} overlayStyle={{ minWidth: 700 }} overlayClassName='roles-tooltip' placement="right" arrowPointAtCenter={false} title={<FlexColumn>
                                        {
                                            <Text color='white' size='14px' noWrap>This indicates the number of days past the invoice date during which the invoice will be eligible</Text>
                                        }
                                    </FlexColumn>}>
                                        <div style={{ float: "right", width: 30 }}>
                                            <Image src={Info} />
                                        </div>
                                    </Tooltip>
                                </>
                            }
                            labelcolor={theme.colors.secondary3}
                            // symbolprefix="%"
                            id="invoiceEligibility"
                            key="invoiceEligibility"
                            placeholder="80.00"
                            onChange={this.handleInvoiceEligibility}
                            optional
                            value={invoiceEligibility}
                        />
                    </Flex>
                    <Flex start style={{ marginBottom: 15 }}>
                        <LabeledInput
                            autoFocus
                            label="Cross Age Limit"
                            labelcolor={theme.colors.secondary3}
                            symbolprefix="%"
                            id="crossAgeLimit"
                            key="crossAgeLimit"
                            placeholder="80.00"
                            onChange={this.handleCrossAgeLimit}
                            optional
                            value={crossAgeLimit}
                        />
                    </Flex>
                    <Flex start style={{ marginBottom: 15 }}>
                        <LabeledInput
                            autoFocus
                            label="Concentration Limit"
                            labelcolor={theme.colors.secondary3}
                            symbolprefix="%"
                            id="concentrationLimit"
                            key="concentrationLimit"
                            placeholder="80.00"
                            onChange={this.handleConcentrationLimit}
                            optional
                            value={concentrationLimit}
                        />
                    </Flex>
                    <Flex start style={{ marginBottom: 15 }}>
                        <LabeledInput
                            autoFocus
                            label="Advance Rate"
                            labelcolor={theme.colors.secondary3}
                            symbolprefix="%"
                            id="advanceRate"
                            key="advanceRate"
                            placeholder="80.00"
                            onChange={this.handleAdvanceRate}
                            optional
                            value={advanceRate}
                        />
                    </Flex>
                    <Flex start style={{ marginBottom: 15 }}>
                        <LabeledInput
                            autoFocus
                            label="Reason"
                            type="text-area"
                            labelcolor={theme.colors.secondary3}
                            id="reason"
                            key="reason"
                            placeholder="Add your reason for update"
                            onChange={this.handleReason}
                            value={reason}
                            error={errorField == "reason"}
                            errorMessage={errorMessage}
                        />
                    </Flex>
                    <Flex start style={{ marginBottom: 15 }}>
                        <Button primary solid loading={loading} onClick={this.handleSubmit} text="Save" />
                    </Flex>
                </FlexColumn>
            </FlexColumn>
        )
    }
}

function mapStateToProps(state) {
    return {
        aionStore: state.aionAppReducer,
        receivablesStore: state.receivablesAppReducer,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTheme(Index))